import { render, staticRenderFns } from "./microsoft-2fa.vue?vue&type=template&id=03f468f6&"
import script from "./microsoft-2fa.vue?vue&type=script&lang=js&"
export * from "./microsoft-2fa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports